import { ActionType, createAction } from 'typesafe-actions'

export const NavMenuActions = {
  toggle: createAction('NavMenu/toggle')<{ name: string }>(),
  close: createAction('NavMenu/close')<{ name: string }>()
}

export type NavMenuActions = ActionType<typeof NavMenuActions>
